import React, { Fragment } from 'react';
import { Checkbox } from '@pwc/pwc-deals-ui';

const CheckboxFormikField = ({ field, label, dataTestId, disabled }) => {
  return (
    // We have to actually destroy the checkbox when the value changes programmatically
    <Fragment key={field.value}>
      <Checkbox
        dataTestId={dataTestId}
        selected={field.value}
        id={field.name}
        label={label}
        onChange={field.onChange}
        onBlur={field.onBlur}
        disabled={disabled}
      />
    </Fragment>
  );
};

export default CheckboxFormikField;
